import {
  API_ENDPOINT,
  useClientApiV1MockInterviewVoucherFreeCreateMutation,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewVoucherFreeMutation {
  options?: Parameters<typeof useClientApiV1MockInterviewVoucherFreeCreateMutation>[0]['options'];
}

export function useMockInterviewVoucherFreeCreateMutation({
  options,
}: UseClientV1MockInterviewVoucherFreeMutation) {
  return useClientApiV1MockInterviewVoucherFreeCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEW_VOUCHER_FREE,
    options,
  });
}
